import { CombinedError } from '@urql/core'
import { authExchange } from '@urql/exchange-auth'
import * as T from 'fp-ts/Task'
import * as TO from 'fp-ts/TaskOption'
import { Exchange } from 'urql'
import { pipe } from 'fp-ts/function'

export const isAuthError = (error: CombinedError) =>
  error.response?.status === 401

export interface AuthExchangeProps {
  getAccessToken(): TO.TaskOption<string>
  refreshToken?(): TO.TaskOption<string>
  logout(): void
}

export const createAuthExchange = ({
  getAccessToken,
  refreshToken
}: AuthExchangeProps): Exchange =>
  authExchange(async (utils) => {
    const getToken = pipe(
      getAccessToken(),
      TO.getOrElseW(() =>
        T.fromIO(() => {
          //logout()

          return null
        })
      )
    )

    let token = await getToken()

    return {
      willAuthError: (_operation) => {
        if (!token) {
          return true
        }

        return false
      },
      didAuthError: (error, _operation) => {
        return isAuthError(error)
      },
      addAuthToOperation: (operation) => {
        if (!token) {
          return operation
        }

        return utils.appendHeaders(operation, {
          Authorization: `Bearer ${token}`
        })
      },
      refreshAuth: async () => {
        if (!refreshToken) {
          return
        }

        // `refreshToken()` returns a `TaskOption` (a thunk); it must be invoked
        // to actually run the refresh. Update the captured token so subsequent
        // operations use the refreshed value.
        token = await pipe(
          refreshToken(),
          TO.getOrElseW(() => T.fromIO(() => null))
        )()
      }
    }
  })
